<template>
  <div class="web-page">
    <div class="header">
      <div class="web-logo"></div>
    </div>
    <div class="content">
      <div class="title">2019高考真题在线估分</div>
      <div class="estimate-num">
        <span v-for="n in numbers">{{n}}</span>
      </div>
      <div class="desc">在线估分考生人数</div>
      <div class="ercode">
        <p>扫码闪电估分</p>
        <img width="114" height="114" src="//gallery.fbcontent.cn/api/ape/images/15bfc571794b116.png" alt="">
      </div>
    </div>
    <div class="footer">
      <div class="copyright" @click="gotoUrl()">北京贞观雨科技有限公司版权所有 关于我们</div>
    </div>
  </div>
</template>

<script>
import apiService from '../services/api'
export default {
  name: 'web-page',
  data () {
    return {
      numbers: [0, 0, 0, 0, 0, 0]
    }
  },
  created () {
    apiService.getEstimateStat(855, 1).then(res => {
      const userCount = '' + res.body.userCount
      const count = '0'.repeat(6 - userCount.length) + userCount
      this.numbers = count.split('')
    })
  },

  methods: {
    gotoUrl () {
      window.location.href = 'https://ytk.yuanfudao.com/ape-web-page/3343'
    }
  }
}
</script>
<style scoped>
.web-page {
  position: relative;
  height: 100%;
}
.header {
  padding-top: 16px;
  height: 66px;
  width: 100%;
  box-sizing: border-box;
  background: #FFF;
}
.web-logo {
  margin-left: 55px;
  width: 140px;
  height: 34px;
  background: url('//gallery.fbcontent.cn/api/ape/images/15bfc0ab086dd60.png') no-repeat;
  background-size: contain;
}
.content {
  width: 100%;
  text-align: center;
  height: 100%;
  background: #0099FF;
  background: url('//gallery.fbcontent.cn/api/ape/images/15c3f53ba6471f3.png') no-repeat;
  background-size: cover;
  overflow-y: scroll;
}

.title {
  margin-top: 100px;
  margin-bottom: 24px;
  font-size: 40px;
  color: #FFF;
}
.estimate-num span {
  display: inline-block;
  margin: 0 5px;
  width: 78px;
  height: 96px;
  background: url('//gallery.fbcontent.cn/api/ape/images/15bfbfbff2826da.png') no-repeat;
  color: #FFF;
  font-size: 60px;
  line-height: 96px;
}
.estimate-num span:nth-of-type(3) {
  margin-right: 20px;
}
.desc {
  margin-top: 16px;
  margin-bottom: 32px;
  color: #FFF;
  font-size: 24px;
}
.ercode {
  margin: 0 auto;
  padding-top: 55px;
  width: 251px;
  height: 272px;
  background: url('//gallery.fbcontent.cn/api/ape/images/15bfbfb0d0c0f6f.png') no-repeat;
}
.ercode p {
  color: #FFF;
  font-size: 16px;
}
.ercode img {
  margin-top: 13px;
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  background: url('//gallery.fbcontent.cn/api/ape/images/15bfbfade1a577c.png') no-repeat;
  background-size: cover;
}
.copyright {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  margin: 10px 0;
  text-align: center;
  font-size: 12px;
  color: #979797;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// WebPage.vue?14b97987